import { Alert, Tag } from "antd";

// Shows who a leave request goes to next, so the requester knows who will approve it.
// approver: { full_name, emp_code, profile_pic_url, identifier? } (backend next_requestee_name shape)
const NextApproverInfo = ({ approver, autoApproved = false }) => {
  if (autoApproved) {
    return (
      <Alert type="success" showIcon style={ { marginBottom: 16 } }
        message="You are the final approver for this employee, so this leave will be approved on save." />
    );
  }
  if (!approver) {
    return null;
  }
  const picture = approver.profile_pic_url && approver.profile_pic_url !== "images/arnold-avatar.jpg"
    ? approver.profile_pic_url
    : "/images/arnold-avatar.jpg";

  return (
    <div style={ {
      display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', marginBottom: 16,
      border: '1px solid #C9D6DF', borderRadius: 8, background: '#F7F9FC',
    } }>
      <img src={ picture } alt="" width={ 40 } height={ 40 } style={ { borderRadius: '50%', flex: '0 0 auto' } } />
      <div style={ { minWidth: 0 } }>
        <div style={ { fontSize: 12, color: '#687980' } }>Next Approver</div>
        <div style={ { fontWeight: 600, overflowWrap: 'anywhere' } }>
          { approver.full_name }{ approver.emp_code ? ` - ${approver.emp_code}` : '' }
          { approver.identifier && <Tag color="blue" style={ { marginLeft: 8 } }>{ approver.identifier }</Tag> }
        </div>
      </div>
    </div>
  );
};

export default NextApproverInfo;
